import React, {useEffect, useState} from "react";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import FriendChallenges from "../components/FriendChallenges";
import Icon from "../components/ui/Icon";
import Avatar from "../components/ui/Avatar";
import {useUser} from "../UserContext";
import {useNotifications} from "../utils/notificationStore";
import {titleFor} from "../utils/pageTitle";

const NAV_ITEMS = [
    {label: "Play", path: "/", icon: "board", match: (p) => p === "/" || p.startsWith("/play") || p.startsWith("/computer")},
    {label: "Social", path: "/social", icon: "users", match: (p) => p.startsWith("/social")},
    {label: "Leaderboards", path: "/leaderboards", icon: "trophy", match: (p) => p.startsWith("/leaderboards")}
];

const HeaderAndFooter = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const user = useUser();
    const {unreadTotal, friendRequests} = useNotifications();
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        setMenuOpen(false);
        window.scrollTo({top: 0});
    }, [location.pathname]);

    useEffect(() => {
        document.title = titleFor(location.pathname, location.search);
    }, [location.pathname, location.search]);

    const go = (path) => {
        setMenuOpen(false);
        navigate(path);
    };

    const profileActive = location.pathname.startsWith("/my-profile") || location.pathname.startsWith("/messages");
    const badgeCount = unreadTotal + friendRequests;

    const navLinks = NAV_ITEMS.map((item) => (
        <button key={item.path} type="button"
                className={`nav-link ${item.match(location.pathname) ? "active" : ""}`}
                aria-current={item.match(location.pathname) ? "page" : undefined}
                onClick={() => go(item.path)}>
            <Icon name={item.icon}/>
            {item.label}
        </button>
    ));

    return (
        <div className="app-shell">
            <header className="site-header">
                <div className="site-header__inner">
                    <button type="button" className="brand" onClick={() => go("/")} aria-label="Chess Corner home">
                        <img src="/logo.png" alt="" className="brand__logo"/>
                        <span className="brand__name">Chess Corner</span>
                    </button>

                    <nav className="main-nav" aria-label="Main">
                        {navLinks}
                    </nav>

                    <div className="header-right">
                        <button type="button"
                                className={`nav-link profile-link ${profileActive ? "active" : ""}`}
                                onClick={() => go("/my-profile")}
                                aria-label="My Profile">
                            {user?.isLoggedIn
                                ? <Avatar name={user.username} size={28}/>
                                : <span className="avatar avatar--guest" style={{"--size": "28px"}}><Icon name="user" size={16}/></span>}
                            <span className="profile-link__label">My Profile</span>
                            {badgeCount > 0 && <span className="nav-link__badge" title="New messages or friend requests">{badgeCount}</span>}
                        </button>
                        <button type="button" className="icon-btn menu-toggle" onClick={() => setMenuOpen((open) => !open)}
                                aria-expanded={menuOpen} aria-label={menuOpen ? "Close menu" : "Open menu"}>
                            <Icon name={menuOpen ? "close" : "menu"}/>
                        </button>
                    </div>
                </div>
            </header>
            <nav className={`mobile-nav ${menuOpen ? "open" : ""}`} aria-label="Main (mobile)" aria-hidden={!menuOpen}>
                {navLinks}
            </nav>

            <main className="app-main">
                <Outlet/>
            </main>

            <footer className="site-footer">
                <div className="site-footer__inner">
                    <span>Chess Corner · If you'll have fun, we'll have you</span>
                    <div className="site-footer__links">
                        <button type="button" onClick={() => navigate("/feedback")}>Feedback</button>
                        <button type="button" onClick={() => navigate("/credits")}>Credits</button>
                    </div>
                </div>
            </footer>

            <FriendChallenges/>
        </div>
    );
};

export default HeaderAndFooter;
